// extracted by mini-css-extract-plugin
export default {"header":"styles_header__NyX8e","logo":"styles_logo__hTa5C","bar":"styles_bar__XGLq5"};